export class ListDatabaseSnapshotsResponse {
    'snapshots';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<DBSnapshotMetadata>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDatabaseSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
